import { StylesForPage } from '../styles';
import { Page } from '@/player-config/src/types/remotion-types';
import { CaptionTransitions } from '@/player-config/src/types/transitions';
import { CAPTIONS_PAGE_GAP_THRESHOLD_SECONDS } from '@/player-config/src/constants/Remotion.constants';
import { Word } from '@/player-config/src/types/transcript-types';

function sanitizeWord(word: Word): Word {
  return {
    ...word,
    content: word.content.replace(/,/g, '')
  };
}

export function createOneWordPages({
  captions,
  fps,
  stylesForPage,
  transitions
}: {
  captions: Word[];
  fps: number;
  stylesForPage: StylesForPage;
  transitions?: CaptionTransitions;
}): Page[] {
  const pages: Page[] = [];
  const pageGapThresholdFrames = Math.ceil(fps * CAPTIONS_PAGE_GAP_THRESHOLD_SECONDS);

  for (let i = 0; i < captions.length; i++) {
    const word = sanitizeWord(captions[i]);
    const nextWord = captions[i + 1];

    if (!word.hidden) {
      const fromFrame = Math.round((word.processed_start_time || 0) * fps);
      const naturalEndFrame = Math.round((word.processed_end_time || 0) * fps);

      let toFrame = naturalEndFrame;

      if (nextWord) {
        const nextWordStartFrame = Math.round((nextWord.processed_start_time || 0) * fps);
        const gap = nextWordStartFrame - naturalEndFrame;

        if (gap <= pageGapThresholdFrames) {
          toFrame = nextWordStartFrame;
        } else {
          toFrame = naturalEndFrame + pageGapThresholdFrames;
        }
      }

      pages.push({
        text: word.content,
        tokens: [{ text: word.content, fromFrame, toFrame }],
        fromFrame,
        toFrame,
        transitions,
        ...stylesForPage
      });
    }
  }

  return pages;
}
